import { initializeApp } from "firebase/app";
/* https://stackoverflow.com/questions/42711175/what-does-the-symbol-do-in-javascript-imports */
import { firebaseConfig } from "@/config/firebase";

export function initFirebaseApp() {
  console.log("Initializing Firebase App");
  const app = initializeApp(firebaseConfig);
  return app;
}
